import React, { Component } from 'react';
import moment from 'moment';
import cn from 'classnames';
import { I18n } from '@td/shared_utils';

import '../styles.scss';

import { prescriberInfo } from '../utils/prescriberInfo';

class InformationTable extends Component {
  render() {
    const { prescriberInfo: { prescriber, service } } = this.props;

    const dateFormat = 'MM/DD/YYYY';

    const isPrescriberActive = moment(service.activeEndTime).utc() > moment().utc();
    const canReactivate = moment().utc() >= moment(service.activeEndTime).utc().subtract(1, 'year');

    return (
      <table>
        <tbody>
          <tr>
            <td>
              <table>
                <tbody>
                  { prescriber.name.prefix && (
                    <tr data="prefix">
                      <td>
                        <I18n scope="provider.surescripts_registration" text="prefix" />
                      </td>
                      <td>
                        {prescriber.name.prefix}
                      </td>
                    </tr>
                  )}
                  <tr data="name">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="first_name" />
                    </td>
                    <td>
                      {prescriber.name.firstName}
                    </td>
                  </tr>
                  { prescriber.name.middleName && (
                    <tr data="middleName">
                      <td>
                        <I18n scope="provider.surescripts_registration" text="middle_name" />
                      </td>
                      <td>
                        {prescriber.name.middleName}
                      </td>
                    </tr>
                  )}
                  <tr data="lastName">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="last_name" />
                    </td>
                    <td>
                      {prescriber.name.lastName}
                    </td>
                  </tr>
                  { prescriber.name.suffix && (
                    <tr data="suffix">
                      <td>
                        <I18n scope="provider.surescripts_registration" text="suffix" />
                      </td>
                      <td>
                        {prescriber.name.suffix}
                      </td>
                    </tr>
                  )}
                  <tr data="externalRegistrationId">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="spi" />
                    </td>
                    <td>
                      {prescriber.identification.externalRegistrationId}
                    </td>
                  </tr>
                  <tr data="spiExpiration">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="spi_expiration" />
                    </td>
                    <td className={cn({ canReactivate: canReactivate }, { expired: !isPrescriberActive })}>
                      { moment(service.activeEndTime).utc().format(dateFormat) }
                    </td>
                  </tr>
                  <tr data="phone">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="phone" />
                    </td>
                    <td>
                      {prescriber.communicationNumbers.phone.number}
                    </td>
                  </tr>
                  <tr data="fax">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="fax" />
                    </td>
                    <td>
                      {prescriber.communicationNumbers.fax.number}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table>
                <tbody>
                  <tr data="address">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="address" />
                    </td>
                    <td>
                      {prescriber.address.addressLine1}
                      <br />
                      {prescriber.address.addressLine2}
                    </td>
                  </tr>
                  <tr data="city">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="city" />
                    </td>
                    <td>
                      {prescriber.address.city}
                    </td>
                  </tr>
                  <tr data="state">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="state" />
                    </td>
                    <td>
                      {prescriber.address.stateProvince}
                    </td>
                  </tr>
                  <tr data="postal">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="postal" />
                    </td>
                    <td>
                      {prescriber.address.postal}
                    </td>
                  </tr>
                  <tr data="country">
                    <td>
                      <I18n scope="provider.surescripts_registration" text="country" />
                    </td>
                    <td>
                      {prescriber.address.countryCode}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

InformationTable.propTypes = {
  prescriberInfo: prescriberInfo
};

export default InformationTable;
